import React, { Component } from 'react'
import lodash from 'lodash'

import Aux from '../../../../hoc/Auxiliary/Auxiliary'
import EmployeeDetailContent from '../../../../components/PageContent/Employee/EmpDetailContent/EmpDetailContent'
import ActionToModal from '../../../../components/PageContent/Employee/ActionToModal/ActionToModal'
import DelegateModal from '../../../../components/PageContent/Employee/DelegateModal/DelegateModal'
import Alert from '../../../../components/Alert/Alert'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
  checkValidity,
  updateFormOptions,
  updateObject
  // isTrulyEqual
} from '../../../../helpers/utils'
import * as actions from '../../../../store/actions'
import { withTranslate } from 'react-redux-multilingual'
import moment, { isMoment } from 'moment'
// import * as moment from 'moment'

class EmployeeDetail extends Component {
  state = {
    empPositionDetailTemplate: {
      emp_detail_id: {
        label: '',
        elementType: 'static',
        elementConfig: {
          readOnly: true
        },
        valid: true,
        value: ''
      },
      index: {
        label: 'No.',
        elementConfig: {
          readOnly: true
        },
        valid: true,
        value: ''
      },
      company_id: {
        label: this.props.translate('company'),
        elementType: 'newselect',
        elementConfig: {
          placeholder: this.props.translate('select') + this.props.translate('company'),
          options: [],
          dropUp: true
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        // touched: false,
        error: null
      },
      org_id: {
        label: this.props.translate('organization'),
        elementType: 'newselect',
        elementConfig: {
          placeholder: this.props.translate('select') + this.props.translate('organization'),
          dropUp: true,
          options: []
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        // touched: false,
        error: null
      },
      level_id: {
        label: this.props.translate('level'),
        elementType: 'newselect',
        elementConfig: {
          placeholder: 'Select Level',
          dropUp: true,
          options: []
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        // touched: false,
        error: null
      },
      position_id: {
        label: this.props.translate('position'),
        elementType: 'newselect',
        elementConfig: {
          placeholder: this.props.translate('select') + this.props.translate('position'),
          dropUp: true,
          options: []
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        // touched: false,
        error: null
      },
      effective_date: {
        label: this.props.translate('effectiveDate'),
        elementType: 'datePicker',
        elementConfig: {
          placeholder: this.props.translate('effectiveDate')
        },
        value: null,
        validation: {
          required: true,
          isDate: true
        },
        valid: false,
        // touched: false,
        error: null
      },
      weight_percent: {
        label: this.props.translate('weightPercent'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('weightPercent'),
          type: 'number'
        },
        value: '',
        validation: {
          required: true,
          isDecimal: true,
          max: 100
        },
        valid: false,
        // touched: false,
        error: null
      },
      is_main_job: {
        label: this.props.translate('is_Main'),
        elementType: 'checkbox',
        elementConfig: {},
        value: false,
        validation: {},
        valid: true,
        // touched: false,
        error: null
      },
      is_active: {
        label: this.props.translate('active'),
        elementType: 'checkbox',
        elementConfig: {},
        value: true,
        validation: {},
        valid: true,
        // touched: false,
        error: null
      },
      action2: {
        value: []
      },
      delegate: {
        value: []
      }
    },
    actionToRowTemplate: {
      assessor_group_id: {
        value: 0,
        valid: true
      },
      seq_no: {
        label: this.props.translate('seqNo'),
        elementType: 'input',
        elementConfig: {
          placeholder: 'Seq No.',
          inputProps: {
            maxLength: 3
          }
        },
        valid: false,
        validation: {
          required: true,
          isDecimal: true
        },
        value: '',
        touched: false,
        error: null
      },
      position_group_id: {
        label: this.props.translate('positionGroup'),
        elementType: 'newselect',
        elementConfig: {
          placeholder: this.props.translate('select') + this.props.translate('positionGroup'),
          dropUp: true,
          options: []
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      emp_id: {
        label: this.props.translate('employee'),
        elementType: 'newselect',
        elementConfig: {
          placeholder: this.props.translate('select') + this.props.translate('employee'),
          options: []
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      position_id: {
        label: this.props.translate('position'),
        elementType: 'newselect',
        elementConfig: {
          placeholder: this.props.translate('select') + this.props.translate('position'),
          options: []
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      org_id: {
        label: this.props.translate('organization'),
        elementType: 'newselect',
        elementConfig: {
          placeholder: this.props.translate('select') + this.props.translate('organization'),
          options: []
          // disabled: true
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      }
      // level_id: {
      //   label: 'Level',
      //   elementType: 'newselect',
      //   elementConfig: {
      //     placeholder: 'Select Level',
      //     options: []
      //   },
      //   value: '',
      //   validation: {
      //     required: true
      //   },
      //   valid: false,
      //   touched: false,
      //   error: null
      // }
    },
    delegateRowTemplate: {
      seq_no: {
        label: this.props.translate('seqNo'),
        dataType: 'text',
        value: ''
      },
      emp_id: {
        label: this.props.translate('employee'),
        dataType: 'text',
        value: ''
      },
      position_id: {
        label: this.props.translate('position'),
        dataType: 'text',
        value: ''
      },
      start_date: {
        label: this.props.translate('startDate'),
        dataType: 'date',
        value: null
      },
      end_date: {
        label: this.props.translate('endDate'),
        dataType: 'date',
        value: null
      },
      from_emp_detail_id: {
        label: '',
        dataType: 'static',
        value: null
      },
      emp_delegate_id: {
        label: '',
        dataType: 'static',
        value: null
      },
      is_cancel: {
        label: this.props.translate('cancel'),
        value: false,
        dataType: 'checkbox'
      }
    },
    form: {
      emp_code: {
        label: this.props.translate('empCode'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('empCode')
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      full_name: {
        label: this.props.translate('employeeName'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('employeeName')
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      company_id: {
        label: this.props.translate('company'),
        elementType: 'newselect',
        elementConfig: {
          placeholder: this.props.translate('select') + this.props.translate('company'),
          options: []
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      working_start_date: {
        label: this.props.translate('workingStartDate'),
        elementType: 'datePicker',
        elementConfig: {
          placeholder: this.props.translate('workingStartDate'),
          options: []
        },
        value: null,
        validation: {
          required: true,
          isDate: true
        },
        valid: false,
        touched: false,
        error: null
      },
      working_age: {
        label: this.props.translate('workingAge'),
        elementType: 'input',
        elementConfig: {
          readOnly: true
        },
        value: '',
        validation: {},
        valid: true,
        touched: false,
        error: null
      },
      emp_type_id: {
        label: this.props.translate('empType'),
        elementType: 'newselect',
        elementConfig: {
          placeholder: this.props.translate('empType'),
          options: []
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      effective_date: {
        label: this.props.translate('effectiveDate'),
        elementType: 'datePicker',
        elementConfig: {
          placeholder: this.props.translate('effectiveDate')
        },
        value: null,
        validation: {
          required: true,
          isDate: true
        },
        valid: false,
        touched: false,
        error: null
      },
      email: {
        label: this.props.translate('eMail'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('eMail')
        },
        value: '',
        validation: {
          required: false,
          isEmail: true
        },
        valid: true,
        touched: false,
        error: null
      },
      probation_end_date: {
        label: this.props.translate('probationEndDate'),
        elementType: 'datePicker',
        elementConfig: {
          placeholder: this.props.translate('probationEndDate')
        },
        value: null,
        validation: {
          required: true,
          isDate: true
        },
        valid: false,
        touched: false,
        error: null
      }
    },
    empPositionDetails: [
      {
        index: {
          label: 'No.',
          elementConfig: {
            readOnly: true
          },
          valid: true,
          value: 1
        },
        company_id: {
          label: this.props.translate('company'),
          elementType: 'newselect',
          elementConfig: {
            placeholder: this.props.translate('select') + this.props.translate('company'),
            options: []
          },
          value: '',
          validation: {
            required: true
          },
          valid: false,
          touched: false,
          error: null
        },
        org_id: {
          label: this.props.translate('organization'),
          elementType: 'newselect',
          elementConfig: {
            placeholder: this.props.translate('select') + this.props.translate('organization'),
            options: []
          },
          value: '',
          validation: {
            required: true
          },
          valid: false,
          touched: false,
          error: null
        },
        level_id: {
          label: this.props.translate('level'),
          elementType: 'newselect',
          elementConfig: {
            placeholder: 'Select Level',
            options: []
          },
          value: '',
          validation: {
            required: true
          },
          valid: false,
          touched: false,
          error: null
        },
        position_id: {
          label: this.props.translate('position'),
          elementType: 'newselect',
          elementConfig: {
            placeholder: this.props.translate('select') + this.props.translate('position'),
            options: []
          },
          value: '',
          validation: {
            required: true
          },
          valid: false,
          touched: false,
          error: null
        },
        effective_date: {
          label: this.props.translate('effectiveDate'),
          elementType: 'datePicker',
          elementConfig: {
            placeholder: this.props.translate('effectiveDate')
          },
          value: null,
          validation: {
            required: true,
            isDate: true
          },
          valid: false,
          touched: false,
          error: null
        },
        weight_percent: {
          label: this.props.translate('weightPercent'),
          elementType: 'input',
          elementConfig: {
            placeholder: this.props.translate('weightPercent'),
            type: 'number'
          },
          value: 100,
          validation: {
            required: true,
            isDecimal: true
          },
          valid: true,
          touched: false,
          error: null
        },
        is_main_job: {
          label: this.props.translate('is_Main'),
          elementType: 'checkbox',
          elementConfig: {},
          value: true,
          validation: {},
          valid: true,
          touched: false,
          error: null
        },
        is_active: {
          label: this.props.translate('active'),
          elementType: 'checkbox',
          elementConfig: {},
          value: true,
          validation: {},
          valid: true,
          touched: false,
          error: null
        },
        action2: {
          value: []
        },
        delegate: {
          value: []
        }
      }
    ],
    empPositionActionTo: [],
    delegateForm: {
      emp_id: {
        label: this.props.translate('employee'),
        elementType: 'newselect',
        elementConfig: {
          placeholder: this.props.translate('select') + this.props.translate('employee'),
          options: []
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      position_group_id: {
        label: this.props.translate('positionGroup'),
        elementType: 'newselect',
        elementConfig: {
          placeholder: this.props.translate('select') + this.props.translate('positionGroup'),
          options: []
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      position_id: {
        label: this.props.translate('position'),
        elementType: 'newselect',
        elementConfig: {
          placeholder: this.props.translate('select') + this.props.translate('position'),
          options: []
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      start_date: {
        label: this.props.translate('startDate'),
        elementType: 'datePicker',
        elementConfig: {
          placeholder: this.props.translate('startDate')
        },
        value: null,
        validation: {
          required: true,
          isDate: true,
          minDate: new Date()
        },
        valid: false,
        touched: false,
        error: null
      },
      end_date: {
        label: this.props.translate('endDate'),
        elementType: 'datePicker',
        elementConfig: {
          placeholder: this.props.translate('endDate')
        },
        value: null,
        validation: {
          required: true,
          isDate: true,
          minDate: new Date()
        },
        valid: false,
        touched: false,
        error: null
      },
      from_emp_detail_id: {
        label: '',
        dataType: 'static',
        value: null
      },
      emp_delegate_id: {
        label: '',
        dataType: 'static',
        value: null
      }
    },
    empPositionDelegate: [],
    // formIsValid: true,
    selectedRecord: null,
    imageSrc: '',
    selectedImage: null,
    positionRowIndex: 0,
    primaryRowIndex: null,
    actionToModalOpen: false,
    delegateModalOpen: false,
    assessorGroups: [],
    action: 'add',
    minDate: null
  }
  componentDidMount = () => {
    this.props.fetchAssessorGroups()
    this.props.fetchOptions()
    let emp_id = this.props.match.params.id
    if (+emp_id) {
      this.props.fetchEmpById(emp_id)
      this.setState({ action: 'edit' })
    }
  }

  componentWillUnmount = () => {
    this.clearData()
  }

  componentDidUpdate (prevprops) {
    if (prevprops.success !== this.props.success && this.props.success) {
      this.props.history.push('/employee')
    }
  }

  static getDerivedStateFromProps (props, state) {
    if (
      props.selectedRecord !== state.selectedRecord &&
      props.assessorGroups !== state.assessorGroups &&
      !lodash.isEmpty(props.selectedRecord)
    ) {
      const allDropdownsLoaded = Object.values(props.dropdownOptions).every(dropdownValue => {
        return !!dropdownValue.length
      })

      if (!allDropdownsLoaded) {
        return null
      }
      let workingStartDate = null
      const createObject = (key, value, attr) => {
        const label = {
          company_id: { code: 'company_code', name: 'company_name' },
          emp_type_id: 'value_list_name',
          emp_id: { code: 'emp_code', name: 'full_name' },
          org_id: { code: 'org_code', name: 'org_name' },
          position_id: { code: 'position_code', name: 'position_name' },
          position_group_id: { code: 'position_group_code', name: 'position_group_name' },
          level_id: 'level_name'
        }

        const dropdownKey = {
          company_id: 'companyOptions',
          emp_type_id: 'empTypeOptions',
          emp_id: 'empOptions',
          org_id: 'orgOptions',
          position_id: 'positionOptions',
          position_group_id: 'positionGroupOptions',
          level_id: 'empLevelOptions'
        }
        const keyOptions = {
          company_id: 'company_id',
          emp_type_id: 'value_list_id',
          emp_id: 'emp_id',
          org_id: 'org_id',
          position_id: 'position_id',
          position_group_id: 'position_group_id',
          level_id: 'level_id'
        }
        const form = updateFormOptions(
          props.dropdownOptions[dropdownKey[key]],
          attr,
          keyOptions[key],
          keyOptions[key],
          label[key],
          null,
          false,
          false
        )

        return form.elementConfig.options.find(res => +res.value === +value)
      }
      const updatedForm = Object.entries(state.form).reduce((updatedForm, formItem) => {
        let [formKey, formAttrs] = formItem
        if (props?.selectedRecord[formKey] !== undefined) {
          if (formAttrs.elementType === 'datePicker') {
            formAttrs.value = new Date(props.selectedRecord[formKey])
          } else if (formAttrs.elementType === 'newselect') {
            formAttrs.value = createObject(formKey, props.selectedRecord[formKey], formAttrs)
          } else if (formAttrs.elementType === 'checkbox') {
            formAttrs.value = !!props.selectedRecord[formKey]
          } else {
            formAttrs.value = props.selectedRecord[formKey]
          }

          if (formKey === 'working_start_date') {
            workingStartDate = props.selectedRecord[formKey]
          }
        }

        let emp_id = props.match.params.id
        const { isValid, error } = checkValidity(
          formAttrs.value,
          formAttrs.validation,
          formAttrs.label
        )
        if (emp_id !== 'add') {
          return {
            ...updatedForm,
            [formKey]: { ...formAttrs, valid: isValid, error: error, touched: true }
          }
        } else {
          return {
            ...updatedForm,
            [formKey]: { ...formAttrs, valid: isValid }
          }
        }
      }, {})

      updatedForm.working_age.value = workingStartDate

      let empDetails = []
      let primaryRow = null

      // render details
      if (props.selectedRecord?.empdetails && props.selectedRecord.empdetails.length) {
        empDetails = props.selectedRecord.empdetails.map((item, index) => {
          const template = { ...state.empPositionDetailTemplate }

          if (item.is_main_job) {
            primaryRow = index
          }
          let detailFormRow = Object.entries(template).reduce((detailRow, positionData) => {
            let [positionDataKey, positionDataAttr] = positionData
            if (
              positionDataAttr.elementType === 'static' ||
              positionDataAttr.elementType === 'input'
            ) {
              positionDataAttr.value = item[positionDataKey]
            } else if (item[positionDataKey] !== undefined) {
              if (positionDataAttr.elementType === 'datePicker') {
                positionDataAttr.value = new Date(item[positionDataKey])
              } else if (positionDataAttr.elementType === 'newselect') {
                positionDataAttr.value = createObject(
                  positionDataKey,
                  parseInt(item[positionDataKey]),
                  positionDataAttr
                )
              } else if (positionDataAttr.elementType === 'checkbox') {
                positionDataAttr.value = !!item[positionDataKey]
              } else {
                if (positionDataKey === 'delegate') {
                  item[positionDataKey] = item[positionDataKey].map((res, i) => {
                    return {
                      ...res,
                      seq_no: i + 1,
                      start_date: res.start_date,
                      end_date: res.end_date,
                      is_cancel: +res.is_cancel,
                      position_id: +res.empdetail.position_id,
                      emp_id: +res.empdetail.emp_id
                    }
                  })
                  positionDataAttr.value = item[positionDataKey]
                }
                if (positionDataKey === 'action2') {
                  item[positionDataKey] = item[positionDataKey].map((res, i) => {
                    return {
                      ...res,
                      position_group_id: res.action2_position_group_id
                    }
                  })
                  positionDataAttr.value = item[positionDataKey]
                }
              }
            }

            if (positionDataKey === 'index') {
              positionDataAttr.value = index + 1
            }

            const { isValid } = checkValidity(
              positionDataAttr.value,
              positionDataAttr.validation,
              positionDataAttr.label
            )

            return {
              ...detailRow,
              [positionDataKey]: { ...positionDataAttr, valid: isValid }
            }
          }, {})

          return detailFormRow
        })
      }

      if (empDetails.length === 0) {
        const firstRow = { ...state.empPositionDetailTemplate }
        const firstRowWeight = { ...firstRow.weight_percent, value: 100, valid: true }
        const firstRowIsMain = { ...firstRow.is_main_job, value: true, valid: true }

        const updatedFirstRow = {
          ...firstRow,
          weight_percent: firstRowWeight,
          is_main_job: firstRowIsMain
        }
        empDetails.push(updatedFirstRow)
      }
      return {
        form: updatedForm,
        empPositionDetails: empDetails,
        imageSrc: props.selectedRecord.image_path,
        selectedRecord: props.selectedRecord,
        assessorGroups: props.assessorGroups,
        primaryRowIndex: primaryRow,
        formIsValid: true
      }
    }
    return null
  }

  clearData = () => {
    const clearedDelegateForm = Object.entries(this.state.delegateForm).reduce((cleared, form) => {
      const [formKey, formAttrs] = form
      let value = ''
      if (formAttrs.elementType === 'datePicker') {
        value = null
      } else if (formAttrs.elementType === 'checkbox') {
        value = false
      }
      return {
        ...cleared,
        [formKey]: {
          ...formAttrs,
          value
        }
      }
    }, {})

    const clearedForm = Object.entries(this.state.form).reduce((cleared, form) => {
      const [formKey, formAttrs] = form
      let value = ''
      if (formAttrs.elementType === 'datePicker') {
        value = null
      } else if (formAttrs.elementType === 'checkbox') {
        value = false
      }
      return {
        ...cleared,
        [formKey]: {
          ...formAttrs,
          value
        }
      }
    }, {})
    const clearedPosition = [
      {
        index: {
          label: 'No.',
          elementConfig: {
            readOnly: true
          },
          valid: true,
          value: 1
        },
        company_id: {
          label: this.props.translate('company'),
          elementType: 'newselect',
          elementConfig: {
            placeholder: this.props.translate('select') + this.props.translate('company'),
            options: []
          },
          value: '',
          validation: {
            required: true
          },
          valid: false,
          touched: false,
          error: null
        },
        org_id: {
          label: this.props.translate('organization'),
          elementType: 'newselect',
          elementConfig: {
            placeholder: this.props.translate('select') + this.props.translate('organization'),
            options: []
          },
          value: '',
          validation: {
            required: true
          },
          valid: false,
          touched: false,
          error: null
        },
        position_id: {
          label: this.props.translate('position'),
          elementType: 'newselect',
          elementConfig: {
            placeholder: this.props.translate('select') + this.props.translate('position'),
            options: []
          },
          value: '',
          validation: {
            required: true
          },
          valid: false,
          touched: false,
          error: null
        },
        level_id: {
          label: this.props.translate('level'),
          elementType: 'newselect',
          elementConfig: {
            placeholder: 'Select Level',
            options: []
          },
          value: '',
          validation: {
            required: true
          },
          valid: false,
          touched: false,
          error: null
        },
        effective_date: {
          label: this.props.translate('effectiveDate'),
          elementType: 'datePicker',
          elementConfig: {
            placeholder: this.props.translate('effectiveDate')
          },
          value: null,
          validation: {
            required: true,
            isDate: true
          },
          valid: false,
          touched: false,
          error: null
        },
        weight_percent: {
          label: this.props.translate('weightPercent'),
          elementType: 'input',
          elementConfig: {
            placeholder: this.props.translate('weightPercent'),
            type: 'number'
          },
          value: '',
          validation: {
            required: true,
            isDecimal: true,
            max: 100
          },
          valid: false,
          touched: false,
          error: null
        },
        is_main_job: {
          label: this.props.translate('is_Main'),
          elementType: 'checkbox',
          elementConfig: {},
          value: false,
          validation: {},
          valid: true,
          touched: false,
          error: null
        },
        is_active: {
          label: this.props.translate('active'),
          elementType: 'checkbox',
          elementConfig: {},
          value: false,
          validation: {},
          valid: true,
          touched: false,
          error: null
        },
        action2: {
          value: []
        },
        delegate: {
          value: []
        }
      }
    ]
    this.props.clearRecord()
    this.setState({
      form: clearedForm,
      delegateForm: clearedDelegateForm,
      empPositionDetails: clearedPosition,
      empPositionActionTo: [],
      empPositionDelegate: [],
      formIsValid: false,
      selectedRecord: null,
      imageSrc: '',
      selectedImage: null,
      positionRowIndex: 0,
      primaryRowIndex: null,
      actionToModalOpen: false,
      delegateModalOpen: false
    })
  }

  createObject = (key, value, attr) => {
    const label = {
      company_id: { code: 'company_code', name: 'company_name' },
      emp_type_id: 'value_list_name',
      emp_id: { code: 'emp_code', name: 'full_name' },
      org_id: { code: 'org_code', name: 'org_name' },
      position_group_id: { code: 'position_group_id', name: 'position_group_name' },
      position_id: 'position_name',
      level_id: 'level_name'
    }

    const dropdownKey = {
      company_id: 'companyOptions',
      emp_type_id: 'empTypeOptions',
      emp_id: 'empOptions',
      org_id: 'orgOptions',
      position_group_id: 'positionGroupOptions',
      position_id: 'positionOptions',
      level_id: 'empLevelOptions'
    }
    const keyOptions = {
      company_id: 'company_id',
      emp_type_id: 'value_list_id',
      emp_id: 'emp_id',
      org_id: 'org_id',
      position_group_id: 'position_group_id',
      position_id: 'position_id',
      level_id: 'level_id'
    }
    let valueRet = {}
    if (
      this.props.dropdownOptions[dropdownKey[key]] !== [] &&
      !lodash.isEmpty(this.props.dropdownOptions[dropdownKey[key]])
    ) {
      valueRet = updateFormOptions(
        this.props.dropdownOptions[dropdownKey[key]],
        attr,
        keyOptions[key],
        keyOptions[key],
        label[key],
        null,
        false,
        false
      ).elementConfig.options.find(res => res.value === +value)
    }

    return valueRet
  }
  // Position Records Functions
  addRowClickHandler = () => {
    let detailRows = [...this.state.empPositionDetails]

    const positionRow = Object.entries(this.state.empPositionDetailTemplate).reduce(
      (row, formItem) => {
        let [formKey, formAttr] = formItem

        let value = ''
        if (formAttr.elementType === 'datePicker') {
          value = null
        } else if (formAttr.elementType === 'checkbox') {
          value = false
          if (formKey === 'is_active') {
            value = true
          }
        }
        if (['action2', 'delegate'].includes(formKey)) {
          value = []
        }

        const updatedFormAttr = { ...formAttr, value: value }

        return {
          ...row,
          [formKey]: updatedFormAttr
        }
      },
      {}
    )
    detailRows.push(positionRow)

    this.setState({
      empPositionDetails: detailRows,
      formIsValid: false
    })
  }

  deleteRowClickHandler = rowIndex => {
    const empDetails = [...this.state.empPositionDetails]
    let left = empDetails
    if (empDetails.length > 1) {
      left = empDetails.filter((item, index) => {
        return index !== rowIndex
      })
    }

    this.setState({
      empPositionDetails: left
    })
  }

  rowDetailInputChangedHandler = (formKey, rowIndex, event) => {
    const formItem = { ...this.state.empPositionDetails[rowIndex][formKey] }

    let primaryRowIndex = this.state.primaryRowIndex
    let inputValue = ''

    if (formItem.elementType === 'newselect') {
      inputValue = event
    } else if (formItem.elementType === 'checkbox') {
      inputValue = event.target.checked
    } else if (['datePicker'].includes(formItem.elementType)) {
      inputValue = moment(event) || null
    } else {
      inputValue = event.target.value
    }

    if (primaryRowIndex !== null && primaryRowIndex !== rowIndex && formKey === 'is_main_job') {
      // case primary already exists and attempted to check any other row (do nothing)
      return
    } else if (
      primaryRowIndex !== null &&
      primaryRowIndex === rowIndex &&
      formKey === 'is_main_job'
    ) {
      // case primary exists and unchecked
      primaryRowIndex = null
    } else if (primaryRowIndex === null && formKey === 'is_main_job') {
      // case no primary exists
      primaryRowIndex = rowIndex
    }

    const { isValid } = checkValidity(inputValue, formItem.validation, formItem.label)

    const updatedFormItem = {
      ...formItem,
      value: inputValue,
      valid: isValid,
      // error: error,
      touched: true
    }
    let updatedForms = updateObject(this.state.empPositionDetails[rowIndex], {
      [formKey]: updatedFormItem
    })
    let formIsValid = true
    Object.entries(updatedForms).map(form => {
      let [, formAttrs] = form
      if (formAttrs.valid !== undefined) {
        return (formIsValid = formIsValid && formAttrs.valid)
      } else {
        return form
      }
    })

    let oldDetails = [...this.state.empPositionDetails]

    // const CurrentDate = new Date();
    // let positionWeight = oldDetails.map((item, index) => {
    //   if (index === rowIndex) {
    //     return updatedForms
    //   }
    //   return item
    // })

    // let weightPosition = positionWeight.filter(item => item.effective_date.value >= CurrentDate && item.is_active.value)

    // let sumWeight = lodash.sumBy(weightPosition, position =>  +position.weight_percent.value || 0)

    this.setState({
      empPositionDetails: oldDetails.map((item, index) => {
        if (index === rowIndex) {
          return updatedForms
        }
        return item
      }),
      primaryRowIndex: primaryRowIndex,
      formIsValid: formIsValid
    })
  }

  // Action To Modal Funtions

  // Open Modal
  actionToClickHandler = rowIndex => {
    let param = null
    if (this.state.empPositionDetails[rowIndex].company_id.value !== '') {
      param = { company_id: this.state.empPositionDetails[rowIndex].company_id.value.value }
    }

    this.props.fetchOptions(param)
    let actionTo = []

    const targetPosition = this.state.empPositionDetails[rowIndex]

    if (targetPosition.action2) {
      const actionToData = targetPosition.action2.value

      actionTo = this.props.assessorGroups.map(assessorGroup => {
        const { value_list_id, value_list_name, value_list_code } = assessorGroup

        const recordsbyGroup = actionToData
          .filter(item => item.assessor_group_id === value_list_id)
          .map(actionTo => {
            const transformedActionTo = Object.entries(this.state.actionToRowTemplate).reduce(
              (transformed, formItem) => {
                let [itemKey, itemAttr] = formItem

                let updateditemAttr = {
                  ...itemAttr,
                  value: actionTo[itemKey]
                }

                if (['emp_id', 'org_id', 'position_id', 'level_id'].includes(itemKey)) {
                  if ('emp_id' === itemKey) {
                    // updateditemAttr = updateFormOptions(this.props.dropdownOptions.empOptions,updateditemAttr,itemKey,itemKey,'full_name')
                  }
                  if (actionTo.empdetail && !actionTo[itemKey]?.value?.value) {
                    updateditemAttr = {
                      ...itemAttr,
                      value: this.createObject(itemKey, actionTo.empdetail[itemKey], itemAttr)
                    }
                  } else {
                    updateditemAttr = actionTo[itemKey]
                  }
                }
                if ('position_group_id' === itemKey) {
                  updateditemAttr = {
                    ...itemAttr,
                    value: this.createObject(itemKey, actionTo.action2_position_group_id, itemAttr)
                  }
                  // updateditemAttr = updateFormOptions(this.props.dropdownOptions.positionsGroupOptions,updateditemAttr,itemKey,itemKey,'position_group_name')
                }

                return {
                  ...transformed,
                  [itemKey]: updateditemAttr
                }
              },
              { ...actionTo }
            )

            return transformedActionTo
          })

        return {
          groupId: value_list_id,
          groupName: value_list_name,
          groupCode: value_list_code,
          collapsed: value_list_id !== 1,
          positionIndex: rowIndex,
          records: recordsbyGroup
        }
      })
    }

    this.setState({
      positionRowIndex: rowIndex,
      actionToModalOpen: true,
      empPositionActionTo: actionTo
    })
  }

  closeActionToModal = () => {
    this.setState({
      actionToModalOpen: false
    })
  }

  actionToInputChangeHandler = (groupId, index, formKey, event) => {
    const updated = this.state.empPositionActionTo.map(item => {
      if (item.groupId === groupId) {
        const targetRow = item.records[index]
        let formItem = targetRow[formKey]
        let inputValue = ''

        if (formItem.elementType === 'newselect') {
          inputValue = event
        } else if (['datePicker'].includes(formItem.elementType)) {
          inputValue = event
        } else {
          inputValue = event.target.value
        }

        const { isValid, error } = checkValidity(inputValue, formItem.validation, formItem.label)

        const updatedFormItem = {
          ...formItem,
          value: inputValue,
          valid: isValid,
          error: error,
          touched: true
        }

        let updatedRow = updateObject(targetRow, { [formKey]: updatedFormItem })

        if (formKey === 'emp_id' && !lodash.isNull(inputValue)) {
          let mainJob = this.props.dropdownOptions.empOptions
            .find(res => res.emp_id === inputValue?.value)
            .empdetails.find(main => main.is_main_job === 1)

          let mainPosition = this.createObject(
            'position_id',
            parseInt(mainJob.position_id),
            targetRow.position_id
          )

          let mainOrg = this.createObject('org_id', parseInt(mainJob.org_id), targetRow.org_id)

          // let mainLevel = this.createObject(
          //   'level_id',
          //   parseInt(mainJob.level_id),
          //   targetRow.level_id
          // )
          updatedRow = updateObject(targetRow, {
            [formKey]: updatedFormItem,
            // position_group_id: { ...targetRow.position_group_id, value: mainPositionGroup },
            position_id: { ...targetRow.position_id, value: mainPosition },
            org_id: { ...targetRow.org_id, value: mainOrg }
            // level_id: { ...targetRow.level_id, value: mainLevel }
          })
        }
        if (formKey === 'position_id') {
          let findDetailPosition = this.props.dropdownOptions.empOptions
            .find(res => {
              return res.emp_id === targetRow.emp_id.value.value
            })
            .empdetails.find(item => parseInt(item.position_id) === event.value)

          let Org = this.createObject('org_id', findDetailPosition.org_id, targetRow.org_id)

          updatedRow = updateObject(targetRow, {
            [formKey]: updatedFormItem,
            org_id: { ...targetRow.org_id, value: Org }
          })
        }

        item.records[index] = updatedRow
      }

      return item
    })

    let formIsValid = true

    Object.entries(updated).map(form => {
      let [, formAttrs] = form
      return (formIsValid = formIsValid && formAttrs.valid)
    })
    this.setState({
      empPositionActionTo: updated
    })
  }

  saveActionToData = () => {
    let data = []

    const positionIndex = this.state.positionRowIndex

    this.state.empPositionActionTo.forEach(group => {
      group.records.forEach(record => {
        data.push(
          Object.entries(record).reduce(
            (recordData, form) => {
              let [formKey, formAttrs] = form
              if (formKey === 'empdetail' || formKey === 'emp_detail_id') {
                return updateObject(recordData, { [formKey]: formAttrs })
              } else if (formKey === 'emp_id') {
                let emp = this.props.dropdownOptions.empOptions.find(
                  item => item.emp_id === formAttrs.value?.value
                )
                let emp_datail_id = null
                let position_id = recordData?.position_id?.value?.position_id || null
                let org_id = recordData?.org_id?.value?.org_id || null
                if (position_id) {
                  emp_datail_id = emp.empdetails.find(
                    e => +e?.position_id === +position_id
                  )?.emp_detail_id
                }
                if (org_id) {
                  emp_datail_id = emp.empdetails.find(e => +e?.org_id === +org_id)?.emp_detail_id
                }

                if (!emp_datail_id) {
                  emp_datail_id = emp.empdetails[positionIndex]?.emp_detail_id
                }

                if (!emp_datail_id) {
                  emp_datail_id = emp.empdetails[positionIndex - 1]?.emp_detail_id
                }

                return updateObject(recordData, {
                  action2_emp_detail_id: emp_datail_id
                })
              } else if (formKey === 'position_group_id') {
                return updateObject(recordData, {
                  action2_position_group_id: formAttrs.value.value
                })
              } else if (formKey === 'org_id' || formKey === 'position_id') {
                return {
                  ...recordData
                }
              } else if (
                formKey === 'action2_position_group_id' ||
                formKey === 'action2_emp_detail_id'
              ) {
                return {
                  ...recordData
                }
              } else {
                if (formAttrs?.elementType === 'newselect') {
                  formAttrs.value = parseInt(formAttrs.value?.value)
                }
                return updateObject(recordData, { [formKey]: formAttrs?.value })
              }
            },
            { ...record }
          )
        )
      })
    })
    const updatedPositionRows = this.state.empPositionDetails.map((position, index) => {
      if (index === positionIndex) {
        position.action2.value = data
      }
      return position
    })

    this.setState({
      empPositionDetails: updatedPositionRows,
      actionToModalOpen: false
    })
  }

  addActionToRowClickHandler = groupId => {
    const updated = this.state.empPositionActionTo.map(item => {
      if (item.groupId === groupId) {
        const updatedActionTo = {
          ...this.state.actionToRowTemplate,
          assessor_group_id: { value: groupId, valid: true }
        }
        const updatedRecords = [...item.records, { ...updatedActionTo }]
        return { ...item, records: updatedRecords }
      }
      return item
    })
    this.setState({
      empPositionActionTo: updated
    })
  }

  deleteActionToRowClickHandler = (groupId, index) => {
    const updated = this.state.empPositionActionTo.map(item => {
      if (item.groupId === groupId) {
        item.records.splice(index, 1)
      }
      return item
    })
    this.setState({
      empPositionActionTo: updated
    })
  }

  actionToCollapseClickHandler = groupId => {
    this.setState(prevState => {
      const updated = prevState.empPositionActionTo.map(item => {
        if (item.groupId === groupId) {
          item.collapsed = !item.collapsed
        }
        return item
      })

      return {
        empPositionActionTo: updated
      }
    })
  }

  // Delegate Modal Functions
  delegateClickHandler = rowIndex => {
    let transformedDelegates = []

    const targetPosition = { ...this.state.empPositionDetails[rowIndex] }
    if (targetPosition?.delegate) {
      const delegateData = targetPosition.delegate.value

      transformedDelegates = delegateData.map(delegate => {
        const transformedDelegate = Object.entries(this.state.delegateRowTemplate).reduce(
          (transformed, template) => {
            let [itemKey, itemAttr] = template
            const updateditemAttr = { ...itemAttr, value: delegate[itemKey] }

            return {
              ...transformed,
              [itemKey]: updateditemAttr
            }
          },
          {}
        )

        return transformedDelegate
      })
    }
    this.clearDelegateForm(false, transformedDelegates)
    this.setState({
      positionRowIndex: rowIndex,
      empPositionDelegate: transformedDelegates,
      delegateModalOpen: true
    })
  }

  closeDelegateModal = () => {
    this.clearDelegateForm(true)
    this.setState({
      delegateModalOpen: false
    })
  }

  clearDelegateForm = (edit, updatedRows) => {
    const clearedDelegateForm = Object.entries(this.state.delegateForm).reduce((cleared, form) => {
      const [formKey, formAttrs] = form
      let value = ''
      let validation = { ...formAttrs.validation }
      if (formAttrs.elementType === 'datePicker') {
        value = null
        if (['end_date', 'start_date'].includes(formKey) && !edit && updatedRows.length > 0) {
          validation = {
            ...validation,
            minDate: moment(updatedRows[updatedRows.length - 1].end_date.value).add(1, 'days')
          }
        }
      }
      return {
        ...cleared,
        [formKey]: {
          ...formAttrs,
          value,
          validation
        }
      }
    }, {})

    this.setState({
      delegateForm: clearedDelegateForm
    })
  }

  delegateInputChangeHandler = (formKey, event) => {
    let inputValue = null

    const targetForm = this.state.delegateForm[formKey]

    if (['newselect', 'newmultiSelect'].includes(targetForm.elementType)) {
      inputValue = event
    } else if (['datePicker'].includes(targetForm.elementType)) {
      inputValue = event
    } else {
      inputValue = event.target.value
    }

    const { isValid, error } = checkValidity(inputValue, targetForm.validation, targetForm.label)

    const updatedFormItem = {
      ...targetForm,
      value: inputValue,
      valid: isValid,
      error: error,
      touched: true
    }
    let updatedForms = updateObject(this.state.delegateForm, { [formKey]: updatedFormItem })

    if (formKey === 'start_date') {
      const endDate = { ...updatedForms.end_date }

      const updatedValidation = { ...endDate.validation, minDate: inputValue }
      const { isValid, error } = checkValidity(endDate.value, updatedValidation, endDate.label)
      const updatedEndDate = {
        ...endDate,
        validation: updatedValidation,
        touched: true,
        valid: isValid,
        error: error
      }

      updatedForms = updateObject(updatedForms, { end_date: updatedEndDate })
      this.setState({
        minDate: moment(inputValue).add(1, 'days')
      })
    }

    if (formKey === 'emp_id' && !lodash.isNull(inputValue)) {
      let mainJob = this.props.dropdownOptions.empOptions
        .find(res => res.emp_id === inputValue?.value)
        .empdetails.find(main => main.is_main_job === 1)
      let positionFormItem = this.state.delegateForm.position_id
      let value = this.createObject('position_id', mainJob?.position_id, positionFormItem)
      const { isValid, error } = checkValidity(
        value,
        positionFormItem.validation,
        positionFormItem.label
      )
      positionFormItem = {
        ...this.state.delegateForm.position_id,
        value: value,
        valid: isValid,
        error: error,
        touched: true
      }

      updatedForms = updateObject(this.state.delegateForm, {
        position_id: positionFormItem,
        [formKey]: updatedFormItem
      })
    }

    this.setState({
      delegateForm: updatedForms
    })
  }

  saveDelegateToData = () => {
    let data = []
    const positionIndex = this.state.positionRowIndex
    this.state.empPositionDelegate.forEach(record => {
      data.push(
        Object.entries(record).reduce((recordData, form) => {
          let [formKey, formAttrs] = form
          if (formAttrs.elementType === 'newselect') {
            formAttrs.value = formAttrs.value?.value.value
          } else if (formAttrs.elementType === 'newmultiSelect') {
            formAttrs.value = formAttrs.value?.value
          }
          if (
            formKey === 'created_by' ||
            formKey === 'created_at'
            // formKey === 'emp_delegate_id'
          ) {
            return {
              ...recordData
            }
          } else {
            return {
              ...recordData,
              [formKey]: formAttrs.value
            }
          }
        }, {})
      )
    })

    const updatedPositionRows = this.state.empPositionDetails.map((position, index) => {
      if (index === positionIndex) {
        position.delegate.value = data
      }
      return position
    })
    this.setState({
      empPositionDetails: updatedPositionRows
    })
    this.closeDelegateModal()
  }

  addDelegateRowClickHandler = () => {
    const currentRows = this.state.empPositionDelegate

    const length = currentRows.length

    const lastRow = currentRows[length - 1] || null
    const newSeqNo = currentRows.length ? lastRow?.seq_no.value + 1 : 1
    const newRow = Object.entries(this.state.delegateRowTemplate).reduce((mapped, data) => {
      const [dataKey, dataAttr] = data
      let mappedData = null
      let value = null

      if (dataKey === 'seq_no') {
        mappedData = {
          ...dataAttr,
          value: newSeqNo
        }
      } else if (dataKey === 'is_cancel') {
        mappedData = {
          ...dataAttr,
          value: false
        }
      } else {
        if (dataAttr.dataType === 'text') {
          value = this.state.delegateForm[dataKey].value.value
        } else {
          value = this.state.delegateForm[dataKey].value
        }
        mappedData = {
          ...dataAttr,
          value: value
        }
      }

      return updateObject(mapped, { [dataKey]: mappedData })
    }, {})

    const delegateForm = this.state.delegateForm
    const startDateInput = this.state.delegateForm.start_date
    const updatedValidation = {
      ...startDateInput.validation,
      minDate: moment(delegateForm.end_date.value).add(1, 'days')
    }
    const { isValid, error } = checkValidity(
      startDateInput.value,
      updatedValidation,
      startDateInput.label
    )
    const updatedInput = {
      ...startDateInput,
      validation: updatedValidation,
      valid: isValid,
      error: error
    }
    const updatedForm = updateObject(delegateForm, { start_date: updatedInput })

    const updatedRows = [...currentRows, newRow]
    this.setState({
      empPositionDelegate: updatedRows,
      delegateForm: updatedForm
    })
    this.clearDelegateForm(false, updatedRows)
  }

  deleteDelegateRowClickHandler = rowIndex => {
    const updated = this.state.empPositionDelegate.filter((item, index) => {
      return index !== rowIndex
    })

    this.setState({
      empPositionDelegate: updated
    })
  }

  cancelDelegateChangeHandler = (targetIndex, event) => {
    const checked = event.target.checked

    const updatedData = this.state.empPositionDelegate.map((row, index) => {
      if (index === targetIndex) {
        return {
          ...row,
          is_cancel: { ...row.is_cancel, value: checked }
        }
      }
      return row
    })

    this.setState({
      empPositionDelegate: updatedData
    })
  }

  // Profile Form Functions
  formInputChangedHandler = (formKey, event) => {
    console.log('formInputChangedHandler', formKey, event)
    const formItem = { ...this.state.form[formKey] }

    let inputValue = ''

    if (formItem.elementType === 'newselect') {
      inputValue = event
    } else if (formItem.elementType === 'checkbox') {
      inputValue = event.target.checked
    } else if (['datePicker'].includes(formItem.elementType)) {
      inputValue = event
    } else if (formKey === 'image_path') {
      let file = event.target.files[0]
      this.setState({
        selectedImage: file
      })
      return
    } else {
      inputValue = event.target.value
    }

    const { isValid, error } = checkValidity(inputValue, formItem.validation, formItem.label)

    const updatedFormItem = {
      ...formItem,
      value: inputValue,
      valid: isValid,
      error: error,
      touched: true
    }

    let updatedForms = updateObject(this.state.form, { [formKey]: updatedFormItem })

    if (formKey === 'working_start_date') {
      updatedForms.working_age.value = inputValue
    }

    let formIsValid = true

    Object.entries(updatedForms).map(form => {
      let [, formAttrs] = form

      return (formIsValid = formIsValid && formAttrs.valid)
    })

    this.state.empPositionDetails.map(item => {
      Object.entries(item).map(form => {
        let [, formAttrs] = form

        return (formIsValid = formIsValid && formAttrs.valid)
      })
      return item
    })
    this.setState({
      form: updatedForms,
      formIsValid: formIsValid
    })
  }

  // Submit
  formSubmitHandler = () => {
    // let sum = 0
    if (this.state.empPositionDetails.length > 0) {
      // let currentDate = moment(new Date()).format('YYYY-MM-DD')
      // let weightPosition = this.state.empPositionDetails.filter(item => {
      //   let date = item.effective_date.value
      //   if (item.effective_date.value !== null) {
      //     date = moment(item.effective_date.value).format('YYYY-MM-DD')
      //   }
      //   return (
      //     (moment(date).isSame(currentDate) || moment(currentDate).isAfter(date)) &&
      //     item.is_active.value
      //   )
      // })
      // sum = lodash.sumBy(weightPosition, position => +position.weight_percent.value || 0)
      // if (!isTrulyEqual(+sum, +100)) {
      //   return this.props.fireAlert(this.props.translate('totalWeightValidationHelperText'))
      // }
    }
    // Emp Data
    let data = Object.entries(this.state.form).reduce((data, formItem) => {
      let [formKey, formData] = formItem
      let value = formData.value
      if (formData.elementType === 'newselect') {
        value = formData.value?.value
      } else if (formData.elementType === 'datePicker') {
        value = moment(formData.value).format('YYYY-MM-DD')
      }
      return {
        ...data,
        [formKey]: value
      }
    }, {})

    let positionDatas = this.state.empPositionDetails.map(item => {
      return Object.entries(item).reduce((data, formItem) => {
        let [formKey, formAttr] = formItem
        let value = null

        if (formKey === 'action2') {
          let action = formAttr.value.map(item => {
            return {
              assessor_group_id: item.assessor_group_id,
              action2_emp_detail_id: parseInt(item.action2_emp_detail_id),
              action2_position_group_id: item.action2_position_group_id,
              seq_no: item.seq_no
            }
          })
          value = { value: action }
        } else if (formKey === 'delegate') {
          if (formAttr.value) {
            let newValue = formAttr.value.map(res => {
              let emp_data = this.props.dropdownOptions.empOptions.find(
                emp => emp.emp_id === res.emp_id
              )
              let to_emp_detail_id = emp_data.empdetails.find(
                detail => +detail.position_id === +res.position_id
              )?.emp_detail_id
              let startDate = res.start_date
              let endDate = res.end_date

              if (isMoment(startDate)) {
                startDate = startDate.format('YYYY-MM-DD')
              } else {
                startDate = moment(startDate).format('YYYY-MM-DD')
              }

              if (isMoment(endDate)) {
                endDate = endDate.format('YYYY-MM-DD')
              } else {
                endDate = moment(endDate).format('YYYY-MM-DD')
              }

              return {
                ...res,
                start_date: startDate,
                end_date: endDate,
                position_id: res.position_id,
                to_emp_detail_id: to_emp_detail_id,
                is_cancel: !!res.is_cancel
              }
            })
            value = { ...formAttr, value: newValue }
          } else {
            value = null
          }
        } else {
          if (formAttr.elementType === 'newselect') {
            value = formAttr.value?.value
          } else if (formAttr.elementType === 'datePicker') {
            value = moment(formAttr.value).format('YYYY-MM-DD')
          } else {
            value = formAttr.value
          }
        }

        return {
          ...data,
          [formKey]: value
        }
      }, {})
    })

    let recordData = { ...data, empdetails: positionDatas }
    delete recordData.working_age

    let formData = new FormData()
    formData.append('image', this.state.selectedImage)
    formData.append('data', JSON.stringify(recordData))

    let emp_id = this.props.match.params.id

    if (+emp_id) {
      formData.append('_method', 'PATCH')
      this.props.updateEmp(emp_id, formData)
    } else {
      this.props.createEmp(formData)
    }
  }

  // checkDisable = () => {
  //   return (
  //     Object.keys(this.props.selectedRecord).length === 0 && this.props.selectedRecord.constructor
  //   )
  // }
  checkValidate = () => {
    let valid = true

    Object.entries(this.state.form).map(item => {
      let [groupKey, groupAttrs] = item
      let { isValid } = checkValidity(groupAttrs.value, groupAttrs.validation, groupKey)
      valid = valid && isValid
      return item
    })
    this.state.empPositionDetails.map(emp => {
      Object.entries(emp).map(item => {
        let [groupKey, groupAttrs] = item
        let { isValid } = checkValidity(groupAttrs.value, groupAttrs.validation, groupKey)
        valid = valid && isValid
        return item
      })
      return emp
    })

    return valid
  }
  render () {
    return (
      <Aux>
        <ActionToModal
          actionToData={this.state.empPositionActionTo}
          open={this.state.actionToModalOpen}
          cancelled={this.closeActionToModal}
          submitted={this.saveActionToData}
          inputChanged={this.actionToInputChangeHandler}
          addRowClicked={this.addActionToRowClickHandler}
          deleteRowClicked={this.deleteActionToRowClickHandler}
          collapseClicked={this.actionToCollapseClickHandler}
          dropdownOptions={this.props.dropdownOptions}
          currentCompany={this.state.form.company_id.value?.value}
          currentEmp={this.state.form.emp_code.value}
          loading={this.props.selectRecordLoading}
          // edit={this.checkDisable()}
        />
        <DelegateModal
          delegateData={this.state.empPositionDelegate}
          open={this.state.delegateModalOpen}
          cancelled={this.closeDelegateModal}
          submitted={this.saveDelegateToData}
          inputChanged={this.delegateInputChangeHandler}
          cancelDelegateChanged={this.cancelDelegateChangeHandler}
          addClicked={this.addDelegateRowClickHandler}
          deleteRowClicked={this.deleteDelegateRowClickHandler}
          dropdownOptions={this.props.dropdownOptions}
          currentCompany={this.state.form.company_id.value?.value}
          delegateForm={this.state.delegateForm}
        />
        <Alert />
        <EmployeeDetailContent
          action={this.state.action}
          formControls={this.state.form}
          positionDetails={this.state.empPositionDetails}
          addRowClicked={this.addRowClickHandler}
          deleteRowClicked={this.deleteRowClickHandler}
          actionToClicked={this.actionToClickHandler}
          delegateClicked={this.delegateClickHandler}
          positionInputChanged={this.rowDetailInputChangedHandler}
          inputChanged={this.formInputChangedHandler}
          formIsValid={this.state.formIsValid}
          saved={this.formSubmitHandler}
          cancelled={() => this.props.history.push('/employee')}
          loading={this.props.selectRecordLoading}
          imageSrc={this.state.imageSrc}
          dropdownOptions={this.props.dropdownOptions}
          currentCompany={this.state.form.company_id.value?.value}
          primaryRowIndex={this.state.primaryRowIndex}
          validate={this.checkValidate()}
          // edit={this.checkDisable()}
        />
      </Aux>
    )
  }
}

const mapStateToProps = state => {
  return {
    selectedRecord: state.employees.selectedRecord,
    selectRecordLoading:
      state.employees.selectRecordLoading || state.employees.filterLoadingStates.length > 0,
    assessorGroups: state.employees.assessorGroups.filter(
      item => !['ASG04', 'ASG05'].includes(item.value_list_code)
    ),
    success: state.employees.success,
    dropdownOptions: {
      companyOptions: state.employees.companies,
      empLevelOptions: state.employees.empLevels,
      orgOptions: state.employees.orgs,
      positionOptions: state.employees.positions,
      positionGroupOptions: state.employees.positionsGroup,
      empOptions: state.employees.emps,
      empTypeOptions: state.employees.empTypes
    }
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fireAlert: message =>
      dispatch(
        actions.enqueueSnackbar({
          message: message,
          options: {
            variant: 'error'
          }
        })
      ),
    fetchEmpById: emp_id => dispatch(actions.fetchEmployeeById(emp_id)),
    updateEmp: (emp_id, recordData) => dispatch(actions.updateEmployee(emp_id, recordData)),
    createEmp: recordData => dispatch(actions.createEmployee(recordData)),
    fetchAssessorGroups: () => dispatch(actions.fetchAssessorGroupOptions()),
    clearRecord: () => dispatch(actions.clearSelectedEmployeeRecord()),
    fetchEmpPositon: emp_id => dispatch(actions.clearSelectedEmployeeRecord(emp_id)),
    fetchOptions: filter => {
      dispatch(actions.fetchCompanyOptions())
      dispatch(actions.fetchPositionOptions({ is_position_group_level: false }))
      dispatch(actions.fetchPositionGroupOptions({ ...filter, is_position_group_level: false }))
      dispatch(actions.fetchOrganizationOptions({ is_position_group_level: false }))
      dispatch(actions.fetchEmpLevelOptions())
      dispatch(actions.fetchEmpTypeOptions())
      dispatch(actions.fetchEmployeeOptions({ ...filter, is_position_group_level: false }))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslate(withRouter(EmployeeDetail)))
